var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6.44141 19.5078C6.87109 19.9277 7.57422 19.9277 7.98438 19.5176L13.9902 13.5117L19.9961 19.5176C20.416 19.9277 21.1191 19.9375 21.5391 19.5078C21.959 19.0879 21.959 18.3848 21.5488 17.9746L15.543 11.959L21.5488 5.95312C21.959 5.54297 21.9688 4.83008 21.5391 4.41992C21.1094 4 20.416 4 19.9961 4.41016L13.9902 10.416L7.98438 4.41016C7.57422 4 6.86133 3.99023 6.44141 4.41016C6.02148 4.83984 6.03125 5.55273 6.44141 5.95312L12.4473 11.959L6.44141 17.9746C6.03125 18.375 6.02148 19.0977 6.44141 19.5078Z","fill":"white"}));
}

Close.defaultProps = {"width":"28","height":"24","viewBox":"0 0 28 24","fill":"none"};

module.exports = Close;

Close.default = Close;
